export default __webpack_public_path__ + "5110f9328b61c9f7d53e2969dadcd5da.png";